import {getFastSimonReporting} from "@fast-simon/fast-simon-reporting";
import {platform, Reporting, storeID, uuid} from "../store";
import {get} from "svelte/store"

export function setReporting() {
    getFastSimonReporting({
        storeID: get(storeID),
        uuid: get(uuid),
        platform: get(platform),
    }).then(r => {
        Reporting.update(() => r);
    })
}